import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Button } from '@mui/material';

const OAUTH_STRINGS = appStrings.modules.login.oauth;

type OauthButtonsProps = Readonly<{
  stytchHost: string;
  stytchPublicToken: string;
}>;

const buildGoogleStartUrl = (host: string, publicToken: string): string => {
  const redirect = `${window.location.origin}/auth/callback`;
  const params = new URLSearchParams({
    public_token: publicToken,
    login_redirect_url: redirect,
    signup_redirect_url: redirect,
  });

  return `https://${host}/v1/public/oauth/google/start?${params}`;
};

export const OauthButtons = ({ stytchHost, stytchPublicToken }: OauthButtonsProps) => {
  const isConfigured = !!stytchHost && !!stytchPublicToken;

  if (!isConfigured) {
    // Missing config is a deploy-time mistake (env var missing). Surface it loudly
    // and disable the button so we never navigate to a malformed Stytch URL.
    console.error(
      '[OauthButtons] disabled — stytchHost or stytchPublicToken is empty. Check REACT_APP_STYTCH_HOST and REACT_APP_STYTCH_PUBLIC_TOKEN.',
    );
  }

  const handleGoogleClick = () => {
    window.location.href = buildGoogleStartUrl(stytchHost, stytchPublicToken);
  };

  return (
    <Button
      id="login-oauth-google-button"
      data-ph-capture-attribute-name="login-oauth-google-button"
      fullWidth
      hierarchy="Secondary gray"
      size="lg"
      onClick={handleGoogleClick}
      startIcon={<GoogleGlyph />}
      disabled={!isConfigured}
    >
      {OAUTH_STRINGS.signInWithGoogle}
    </Button>
  );
};

const GoogleGlyph = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
    <path
      d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"
      fill="#4285F4"
    />
    <path
      d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.258c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5832-5.0359-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z"
      fill="#34A853"
    />
    <path
      d="M3.9641 10.71c-.18-.54-.2823-1.1168-.2823-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.9641 10.71z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.9641 7.29C4.6718 5.1628 6.656 3.5795 9 3.5795z"
      fill="#EA4335"
    />
  </svg>
);
